/**
 * @desc 该配置文件是管理所有渲染页面的id的配置文件
 */

// 页面类型
const VIEW_TYPE = {
    EDIT: 'EDIT',
    READ_ONLY: 'READ_ONLY',
    FULL_SCREEN: 'FULL_SCREEN',
};


const RENDER_VIEW_ID_DATA = {
    EDIT: {
        SCENE1: {
            ID: 'edit_scene1',
            CANVAS_ID: 'edit_view',
            ELEMENT_ID: 'edit_element_view',
        },

        SCENE2: {
            ID: 'edit_scene2',
            CANVAS_ID: 'edit_view2',
            ELEMENT_ID: 'edit_element_view2',
        },

        OVERLAY_TRANSITION_ID: 'edit_overlay_transition_view',
        SUBTITLE_ID: 'edit_subtitle_view',
        LIGHT_EFFECT_TRANSITION_ID: 'edit_light_effect_transition_view',
        PREVIEW_BOX_ID: 'edit_preview_box',
    },
    READ_ONLY: {
        SCENE1: {
            ID: 'read_only_scene1',
            CANVAS_ID: 'read_only_view',
            ELEMENT_ID: 'read_only_element_view',
        },
        SCENE2: {
            ID: 'read_only_scene2',
            CANVAS_ID: 'read_only_view2',
            ELEMENT_ID: 'read_only_element_view2',
        },
        OVERLAY_TRANSITION_ID: 'read_only_overlay_transition_view',
        SUBTITLE_ID: 'read_only_subtitle_view',
        PREVIEW_BOX_ID: 'read_only_edit_preview_box',
        LIGHT_EFFECT_TRANSITION_ID: 'read_only_edit_light_effect_transition_view',
    },
    FULL_SCREEN: {
        SCENE1: {
            ID: 'full_screen_scene1',
            CANVAS_ID: 'full_screen_view',
            ELEMENT_ID: 'full_screen_element_view',
        },
        SCENE2: {
            ID: 'full_screen_scene2',
            CANVAS_ID: 'full_screen_view2',
            ELEMENT_ID: 'full_screen_element_view2',
        },
        OVERLAY_TRANSITION_ID: 'full_screen_overlay_transition_view',
        SUBTITLE_ID: 'full_screen_subtitle_view',
        PREVIEW_BOX_ID: 'full_screen_edit_preview_box',
        LIGHT_EFFECT_TRANSITION_ID: 'full_screen_edit_light_effect_transition_view',
    },
};

export { VIEW_TYPE, RENDER_VIEW_ID_DATA };
